import type { CmsArticle } from '@/lib/cms-types';
import { MOCK_PAINEL_USERS } from '@/lib/painel-rbac';

const ACTIVE_USERS = MOCK_PAINEL_USERS.filter((u) => u.status === 'active');

export function getPainelUserInitials(name: string): string {
  const trimmed = name.trim();
  if (!trimmed) return 'XA';
  const parts = trimmed.split(/\s+/);
  if (parts.length >= 2) {
    return `${parts[0][0] ?? ''}${parts[1][0] ?? ''}`.toUpperCase();
  }
  return trimmed.slice(0, 2).toUpperCase();
}

function hashId(id: string): number {
  return id.split('').reduce((acc, ch) => acc + ch.charCodeAt(0), 0);
}

export function resolveArticleActor(
  article: Pick<CmsArticle, 'id' | 'updatedById' | 'updatedByName'>
): { name: string; initials: string } {
  if (article.updatedByName?.trim()) {
    const name = article.updatedByName.trim();
    return { name, initials: getPainelUserInitials(name) };
  }

  if (article.updatedById) {
    const user = MOCK_PAINEL_USERS.find((u) => u.id === article.updatedById);
    if (user) {
      return { name: user.name, initials: getPainelUserInitials(user.name) };
    }
  }

  const user = ACTIVE_USERS[hashId(article.id) % ACTIVE_USERS.length] ?? ACTIVE_USERS[0];
  return { name: user.name, initials: getPainelUserInitials(user.name) };
}
